import { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigate } from 'react-router-dom';

// Ensure GSAP plugins are registered
gsap.registerPlugin(ScrollTrigger);

const CTASection = ({ onLoginClick, onCompanyRegisterClick }) => {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const section = sectionRef.current;
    const content = contentRef.current;
    const particles = document.querySelectorAll('.bg-particle');

    if (section && content) {
      // Content animation
      gsap.fromTo(
        content,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: section,
            start: "top bottom-=100",
            end: "bottom center",
            scrub: 1,
            toggleActions: "play none none reverse",
          },
        }
      );
      
      // Animate background particles
      particles.forEach((particle) => {
        gsap.to(particle, {
          x: `random(-50, 50)`,
          y: `random(-50, 50)`,
          duration: 'random(5, 15)',
          repeat: -1,
          yoyo: true,
          ease: 'sine.inOut',
        });
      });
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, [contentRef, sectionRef]);

  return (
    <section
      ref={sectionRef}
      className="min-h-[60vh] bg-gray-900 py-20 px-4 relative overflow-hidden"
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        {Array.from({ length: 20 }).map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 rounded-full bg-blue-500 opacity-30 bg-particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
          />
        ))}
      </div>

      <div
        ref={contentRef}
        className="container mx-auto text-center relative z-10 max-w-4xl"
      >
        <div
          className="bg-gradient-to-r from-blue-900/70 to-purple-900/70 backdrop-blur-xl rounded-3xl p-10 border border-indigo-500/30 shadow-2xl"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Ready to Transform Your Internship Experience?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
            Whether you're a student seeking opportunities or a company looking
            for talent, the GUC Internship Portal is your gateway to success.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button
              className="px-8 py-4 bg-blue-600 rounded-full font-medium text-lg hover:shadow-lg hover:bg-blue-500 hover:scale-105 transition-all text-white"
              onClick={() => navigate('/login')}
            >
              Login
            </button>

            <button
              className="px-8 py-4 bg-purple-600 rounded-full font-medium text-lg hover:shadow-lg hover:bg-purple-500 hover:scale-105 transition-all text-white"
              onClick={() => navigate('/company-register')}            
            >
              Register as a Company
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
